var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['chat-bubble', _vm.isUser ? 'user' : 'other']},[_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }